import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78f305b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pallet-unlinker-profile-wrapper relative overflow-y-hidden" }
const _hoisted_2 = { class: "pallet-unlinker-profile" }

import { ref } from "vue";
import { get, set } from "@vueuse/core";
import Sidebar from "primevue/sidebar";
import CustomerList from "./CustomerList/index.vue";
import CustomerDetail from "./CustomerDetail/index.vue";
import { ApiCustomerIndexReq, ApiCustomerIndexRes, ApiTagIndexReq, ICustomer, ITag } from "@/clinic/typings";
import { CustomerServices, ClinicService } from "@/clinic/services";
import { AxiosResponse } from "axios";
import { CustomerFilterLineBy } from "@/clinic/typings/enums/customer";


export default /*#__PURE__*/_defineComponent({
  __name: 'RightSideBar',
  props: {
    customerId: null,
    accountId: null,
    clinicId: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  customerId: number;
  accountId?: number;
  clinicId: number;
};



const customer = ref<ICustomer>({} as ICustomer);
const customers = ref<ICustomer[]>([]);
const listTags = ref<ITag[]>([]);
const visibleSideBar = ref<boolean>(false);

const onShow = async () => {
  await handleClickShow();
};

const onClose = () => set(visibleSideBar, false);

// eslint-disable-next-line no-undef
expose({
  onShow,
  onClose,
});

const loadCustomer = async () => {
  const payload = { clinic_id: props.clinicId, id: props.customerId };
  const { data: customerData } = (await CustomerServices.getCustomer(payload)) as unknown as AxiosResponse<ICustomer>;
  set(customer, get(customerData));
};

const handleClickShow = async () => {
  if (props.customerId != 0) {
    await loadCustomer();
  } else {
    const { data } = (await CustomerServices.getCustomers(
      {
        clinic_id: props.clinicId,
        term: "",
        rows: 10,
        page: 0,
        filter_line_by: CustomerFilterLineBy.unlinked,
      } as ApiCustomerIndexReq,
      () => undefined,
      (error: any) => undefined
    )) as unknown as AxiosResponse<ApiCustomerIndexRes>;
    const { customers: customersData } = get(data);
    set(customers, customersData as unknown as ICustomer[]);
  }
  const { data: tagsData } = (await ClinicService.listTags({
    clinic_id: props.clinicId as number,
  } as ApiTagIndexReq)) as unknown as AxiosResponse<ITag[]>;
  set(listTags, get(tagsData));
  set(visibleSideBar, true);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        icon: "pi pi-user",
        onClick: handleClickShow
      })
    ]),
    _createVNode(_unref(Sidebar), {
      visible: visibleSideBar.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visibleSideBar).value = $event)),
      position: "right",
      class: "w-full md:w-20rem lg:w-30rem customer-detail-sidebar",
      id: "direct-messages-right-sidebar"
    }, {
      default: _withCtx(() => [
        (props.customerId == 0)
          ? (_openBlock(), _createBlock(CustomerList, {
              key: 0,
              "account-id": props.accountId,
              tags: listTags.value,
              customers: customers.value,
              "clinic-id": __props.clinicId
            }, null, 8, ["account-id", "tags", "customers", "clinic-id"]))
          : _createCommentVNode("", true),
        (props.customerId != 0)
          ? (_openBlock(), _createBlock(CustomerDetail, {
              key: 1,
              "customer-id": props.customerId,
              "account-id": props.accountId,
              "link-customer": false,
              customer: customer.value,
              tags: listTags.value,
              "clinic-id": __props.clinicId,
              onRefreshCustomer: loadCustomer
            }, null, 8, ["customer-id", "account-id", "customer", "tags", "clinic-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})